var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`Displayer${this.capitalize(this.displayerId)}`,{tag:"component",staticClass:"livedata-displayer",attrs:{"property-id":_vm.propertyId,"entry":_vm.entry}})
}
var staticRenderFns = []

export { render, staticRenderFns }